import React from 'react'
import FundraiserListDataTable from '../../components/Admin/FundraiserList';

const FundraiserList = () => {
  return (
    <FundraiserListDataTable />
  )
}

export default FundraiserList;